export enum TTabStatus {
  MEI_LTDA = 'mei-ltda',
  COOPERATIVE_SA = 'cooperative-sa',
}
